import * as React from "react";
import { Link, withRouter } from "react-router-dom";
import classNames from "classnames";
import { observer } from "mobx-react";
import { AppBar, Tabs, withStyles, CircularProgress } from "@material-ui/core";
import { WBSStore } from "modules/WBS/WBSStore";

const styles = (theme) => ({
  navLink: {
    backgroundColor: "#e4e4e4",
    border: "1px solid #a4a4a4",
    position: "relative" as any,
    height: "28px",
    paddingLeft: "20px",
    paddingRight: "12px",
    color: "#212121",
    fontFamily: "Roboto",
    fontWeight: 700,
    fontSize: "11px",
    display: "flex",
    alignItems: "center",
    textDecoration: "none",
    minWidth: "300px",
    maxWidth: "300px",
  },
  tringle: {
    display: "block",
    position: "absolute" as any,
    left: "100%",
    width: 0,
    height: 0,
    borderStyle: "solid",
    zIndex: 1,
  },
  tringleOne: {
    top: "-2px",
    borderColor: "transparent transparent transparent #a4a4a4",
    borderWidth: "15px 0px 15px 12px",
  },
  text: {
    minWidth: "unset",
    minHeight: "unset",
    display: "block",
    whiteSpace: "nowrap" as any,
    textOverflow: "ellipsis",
    overflow: "hidden",
  },
  tringleTwo: {
    top: "0px",
    borderColor: "transparent transparent transparent #e4e4e4",
    borderWidth: "13px 0px 13px 10px",
  },
  tabsRoot: {
    minHeight: "unset",
  },
  tabsFlexContainer: {
    height: "29px",
  },
  scrollButtons: {
    backgroundColor: "#e4e4e4",
    flex: "0 0 30px",
    border: "1px solid #a4a4a4",
    height: "28px",
  },
});

type INavLinkProps = {
  classes: any;
  url: string;
  style?: React.CSSProperties;
  text?: any;
  getText?: Function;
  onClick?: () => void;
  pathPromises?: {
    array: Array<any>;
    index: number;
    last: boolean;
    breadItemPromise?: Function;
  };
};
class ArrowNavLink extends React.Component<INavLinkProps> {
  state = {
    text: "",
  };
  constructor(props) {
    super(props);
    this.state.text = props.text;
  }
  componentDidMount() {
    const { getText } = this.props;
    if (getText) this.getTextFromAsyncFunction(getText, this.props as any);
  }
  componentWillReceiveProps(nextProps) {
    const { text, getText } = nextProps;
    this.state.text = text;
    if (getText) this.getTextFromAsyncFunction(getText, nextProps);
  }
  getTextFromAsyncFunction = (getText, { url, pathPromises }) => {
    let promise = this.arrayPromise(getText, url, pathPromises);
    if (pathPromises) {
      let { array, index, last, breadItemPromise } = pathPromises;
      if (!array[index]) array.push(promise);
      else {
        array[index] = promise;
        if (last && array[index + 1])
          array.splice(index + 1, array.length - index - 1);
      }
      if (breadItemPromise)
        Promise.resolve(array[index]).then(() =>
          breadItemPromise(index, last, array[index])
        );
    }
  };
  arrayPromise = (getText, url, pathPromises?) =>
    new Promise<void>(async (resolve) => {
      const { response, func } = getText;
      let params = url.split("/");
      let resp = await func(params[params.length - 1]);
      Promise.resolve(resp).then((data) => {
        if (pathPromises) {
          let { array, index, last } = pathPromises;
          let item = array[index];
          if (item.then) array[index] = { url, data };
          else
            array[index] = {
              ...item,
              url,
              data,
            };
          if (last && array[index + 1])
            array.splice(index + 1, array.length - index - 1);
        }
        if (data) {
          this.setState({ text: response ? response(data) : data }, () =>
            resolve()
          );
        }
      });
    });

  render() {
    const {
      props: { url, classes, style },
      state: { text },
    } = this;
    return (
      <Link
        to={url}
        className={classes.navLink}
        onClick={this.props.onClick}
        {...(style && { style })}
      >
        <span className={classNames(classes.tringle, classes.tringleOne)} />
        <div className={classes.text}>
          {text === undefined ? <CircularProgress size={10} /> : text}
        </div>
        <span className={classNames(classes.tringle, classes.tringleTwo)} />
      </Link>
    );
  }
}

type IBreadCrumbProps = {
  classes: any;
  links?: Array<{ url: string; text?: any }>;
  getText: {
    func?: Function;
    response?: Function;
  };
  pathPromisesArray?: Function;
  breadItemPromise?: Function;
  noLinksEvent?: Function;
  textByIndex?: Array<object>;
  root?: { url: string; text?: string; onClick: () => void };
};

@observer
class ArrowBreadCrumb extends React.Component<IBreadCrumbProps> {
  state = {
    links: [],
  };
  constructor(props) {
    super(props);
    this.state.links = this.getLinks(props);
  }
  componentWillReceiveProps(nextProps) {
    this.setState({ links: this.getLinks(nextProps) });
  }

  getLinks = ({ links, root, textByIndex, noLinksEvent }): any => {
    if (links) return links;
    let path = location.pathname,
      first = "/",
      linksArray = [];
    if (root && path.indexOf(root.url) === 0) {
      path = path.substring(root.url.length);
      first = `${root.url}/`;
    }
    let parts = path.split("/");
    parts.splice(0, 1);
    parts.map((item, index) => {
      linksArray.push({
        url: first + parts.slice(0, index + 1).join("/"),
        ...(textByIndex && { text: textByIndex[`i${index}`] }),
      } as never);
    });
    if (noLinksEvent && linksArray.length === 0) noLinksEvent();
    return linksArray;
  };

  render() {
    const {
      props: { classes, getText, pathPromisesArray, breadItemPromise, root },
      state: { links },
    } = this;
    return (
      <div
        className={classes.breadCrumbBar}
        style={{ visibility: WBSStore.displayCostPlan }}
      >
        <AppBar position="static" color="default">
          <Tabs
            value={false}
            variant="scrollable"
            scrollButtons="on"
            classes={{
              root: classes.tabsRoot,
              flexContainer: classes.tabsFlexContainer,
              scrollButtons: classes.scrollButtons,
            }}
          >
            {root && root.text && (
              <ArrowNavLink
                style={{ minWidth: "unset" }}
                classes={classes}
                {...root}
              />
            )}
            {links.map((link, index) => (
              <ArrowNavLink
                classes={classes}
                getText={getText}
                {...(pathPromisesArray && {
                  pathPromises: {
                    array: pathPromisesArray,
                    index,
                    last: index === links.length - 1,
                    breadItemPromise,
                  },
                })}
                {...link}
              />
            ))}
          </Tabs>
        </AppBar>
      </div>
    );
  }
}
export default withStyles(styles)(withRouter(ArrowBreadCrumb));



// WEBPACK FOOTER //
// ./src/common/components/ArrowBreadCrumb.tsx